module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-up-453cb491.svg";